<ng-container *ngIf="{categories: categories$ | async} as data">
  <div class="w-full h-full flex service-group-search-dialog-container flex-col max-w-3xl place-content-between">
    <div class="flex flex-col">
      <div class="flex flex-row place-content-between">
        <span class="text-lg font-semibold pb-9" style="font-family: 'Open Sans';">
          {{modalTitle}}
        </span>
        <div class="cursor-pointer h-6 flex items-center" (click)="cancel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path
              d="M8.65581 9.80657L2.75311 15.7685C2.53226 15.9916 2.25118 16.1031 1.90987 16.1031C1.56856 16.1031 1.28747 15.9916 1.06663 15.7685C0.845776 15.5455 0.735352 15.2616 0.735352 14.9168C0.735352 14.5721 0.845776 14.2882 1.06663 14.0651L6.96933 8.10315L1.06663 2.14117C0.845776 1.9181 0.735352 1.6342 0.735352 1.28946C0.735352 0.944721 0.845776 0.660817 1.06663 0.43775C1.28747 0.214683 1.56856 0.103149 1.90987 0.103149C2.25118 0.103149 2.53226 0.214683 2.75311 0.43775L8.65581 6.39973L14.5585 0.43775C14.7794 0.214683 15.0604 0.103149 15.4018 0.103149C15.7431 0.103149 16.0241 0.214683 16.245 0.43775C16.4658 0.660817 16.5763 0.944721 16.5763 1.28946C16.5763 1.6342 16.4658 1.9181 16.245 2.14117L10.3423 8.10315L16.245 14.0651C16.4658 14.2882 16.5763 14.5721 16.5763 14.9168C16.5763 15.2616 16.4658 15.5455 16.245 15.7685C16.0241 15.9916 15.7431 16.1031 15.4018 16.1031C15.0604 16.1031 14.7794 15.9916 14.5585 15.7685L8.65581 9.80657Z"
              fill="#0054A6" />
          </svg>
        </div>
      </div>
      <div mat-dialog-content class="flex flex-col" style="min-height:43vh;">
        <form class="flex flex-col" style="position:sticky;top:0px;background-color:#FFF;z-index:1;"
          [formGroup]="filterForm">
          <div class="flex flex-row space-x-6">
            <div class="flex flex-col w-1/2">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Search by op
                code or name
              </span>
              <mat-form-field appearance="outline" class="text-sm">
                <input id="opCode" matInput type="text" formControlName="opCode" placeholder="Search"
                  autocomplete="off">
              </mat-form-field>
            </div>
            <div class="flex flex-col w-1/2">
              <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                Category</span>
              <mat-form-field appearance="outline" class="text-sm">
                <mat-select formControlName="categoryId">
                  <mat-option *ngFor="let category of data?.categories?.rooftopCategories | orderBy: 'description'"
                    [value]="category.id">
                    {{category.description}}
                  </mat-option>

                  <mat-optgroup>
                    <label fxFlex class="w-full">
                      Shared
                    </label>
                    <mat-option *ngFor="let category of data?.categories?.sharedCategories | orderBy: 'description'"
                      [value]="category.id">
                      {{category.description}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div fxLayoutAlign="end center" class="pt-0 mr-2 mb-1 ml-2">
            <button (click)="resetServiceGroupFilterForm()"
              class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
              [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}"
              style="font-family: 'Open Sans'; height: 34px" type="submit">
              <span class="text-white font-medium text-sm">Reset</span>
            </button>
          </div>
          <mat-divider class="my-2 mr-0 ml-0"></mat-divider>
        </form>
        <cdk-virtual-scroll-viewport itemSize="50" style="height:390px">
          <div *cdkVirtualFor="let sg of displayedGroups | orderBy: 'name';let i = index; trackBy: trackByMethod"
            (click)="selectServiceGroup(sg)" [class.selectedItem]="sg.id == selectedServiceGroup?.id"
            style="font-family: 'Open Sans';" class="flex flex-col h-14 p-2">
            <span class="font-semibold text-xs"> {{sg.workOrderLocationOpCode
              ? sg.workOrderLocationOpCode : 'No op code for service group'}}</span>
            <span> {{sg.name}} {{sg.estimatedTime ? ' | Estimated Time: ' + (sg.estimatedTime | number: '1.1-1') : ''
              }}</span>
          </div>

        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <div class="w-full h-full bg-white mt-10">
      <div class="flex flex-row place-content-between items-center">
        <button (click)="addCaseManually()" id="saveButton"
          class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
          [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}"
          style="font-family: 'Open Sans'; height: 34px" type="submit">
          <span class="text-white font-medium text-sm">Add Manually</span>
        </button>
        <div class="flex flex-row space-x-3">
          <span (click)="cancel()" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md"
            [ngStyle]="{ border: '1px solid #515251', cursor: 'pointer'}"
            style="font-family: 'Open Sans'; height: 34px">Cancel</span>
          <button (click)="save(selectedServiceGroup)" id="saveButton"
            class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
            [ngStyle]="{ background: selectedServiceGroup ? 'rgba(0, 84, 166, 1)' : 'rgba(81, 82, 81, 0.38)', cursor: selectedServiceGroup ? 'pointer' : 'not-allowed'}"
            [disabled]="selectedServiceGroup == null" style="font-family: 'Open Sans'; height: 34px" type="submit">
            <span class="text-white font-medium text-sm">Add</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>